import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import RootStoreContext from '~/contexts/RootStoreContext';
import {
  actions as commonActions,
  selectors as commonSelectors
} from '~/domains/common';
import {
  actions as modalActions,
  selectors as modalSelectors
} from '~/domains/modal';
import { actions as agentScannersActions } from '~/domains/agentScanners';
import withLayoutContext from '~/components/LayoutContextProvider';
import { setModalType, registerModal } from '~/components/Modals';
import { getPath } from '~/utils/routes';
import DeleteConfirmModal from './DeleteConfirmModal';

const mapStateToProps = (state) => {
  const profile = commonSelectors.profile(state);
  const modalProps = modalSelectors.modalProps(state);

  return {
    profile,
    organizationId: profile?.organization?.id,
    scanConfig: modalProps?.scanConfig,
    navigateToList: modalProps?.navigateToList
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onCancel: () => dispatch(modalActions.closeModal()),
  onConfirm: (scanner, organizationId, navigateToList) => {
    dispatch(
      agentScannersActions.deleteAgentScanner(scanner.id, organizationId)
    )
      .then(() => {
        dispatch(modalActions.closeModal());

        const deleteAlert = {
          type: 'success',
          message: `Agent scanner '${scanner.name}' was deleted.`,
          isHTML: true
        };

        dispatch(commonActions.setAlert(deleteAlert));

        // Navigate to the scanners list if navigateToList is true
        // (used when deleting from the scanner detail view)
        if (navigateToList) {
          if (!ownProps.history) {
            // eslint-disable-next-line no-console
            console.warn(
              'Navigation requested but history object is not available'
            );

            return;
          }

          const scannersListPath = getPath('agentScanners');

          if (!scannersListPath) {
            // eslint-disable-next-line no-console
            console.error('Failed to get scanners list path');

            return;
          }

          ownProps.history.push(scannersListPath);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Failed to delete scanner:', error);
        dispatch(modalActions.closeModal());
      });
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onCancel: dispatchProps.onCancel,
  onConfirm: () =>
    dispatchProps.onConfirm(
      stateProps.scanConfig,
      stateProps.organizationId,
      stateProps.navigateToList
    )
});

export default compose(
  registerModal,
  setModalType('DeleteConfirmModal'),
  withLayoutContext(),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    context: RootStoreContext
  })
)(DeleteConfirmModal);
